import React, { ReactElement, FunctionComponent, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Debug from "debug";
import { Redirect, Route } from "react-router-dom";
import { AuthMode, ViewerStore } from "./types";
import { RootState } from "./reducers";
import { getViewerChannel } from "./actions";
import { getParametersFromUrl } from "./utils/stringUtils";

interface PrivateRouteProps {
  component: FunctionComponent;
  exact?: boolean;
  path: string;
}

const debug = Debug("broadcast:PrivateRoute");

const PrivateRoute = (
  props: PrivateRouteProps
): ReactElement<PrivateRouteProps> => {
  const dispatch = useDispatch();
  const viewer: ViewerStore = useSelector((state: RootState) => state.viewer);

  const { component, path, exact } = props;
  const { orgId, channelId, spaceId } = getParametersFromUrl(
    window.location.pathname
  );

  useEffect(() => {
    if (window.location.pathname.includes("/view/")) {
      dispatch(getViewerChannel({ orgId, spaceId, channelId }));
    }
  }, [dispatch, orgId, spaceId, channelId]);

  const { channel } = viewer;

  if (channel) {
    debug("channel", channel);
    if (channel.authMode === AuthMode.Private) {
      return (
        <div className="full-screen-centered">
          <h2>This stream is for viewing on ScreenCloud screens only.</h2>
          <div>
            If you are the stream creator and would like to enable access via
            this URL, please change the share settings for this stream on
            ScreenCloud Studio.
          </div>
        </div>
      );
    } else if (channel.authMode === AuthMode.Public) {
      debug("public");
      return <Route component={component} path={path} exact={exact} />;
    }
    return !channel.authMode ? (
      <></>
    ) : viewer.token !== null ? (
      <Route component={component} path={path} exact={exact} />
    ) : (
      <Redirect
        to={`/login?redirectUrl=${window.location.pathname}&authMode=${channel.authMode}`}
      />
    );
  }
  return <div />;
};

export default PrivateRoute;
